/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspage_Filter_Kind1Inputs */

const vi_cmspage_filter_kind1 = /** @type {(inputs: Cmspage_Filter_Kind1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại`)
};

/**

* @param {Cmspage_Filter_Kind1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_filter_kind1 = /** @type {((inputs?: Cmspage_Filter_Kind1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_Filter_Kind1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_filter_kind1(inputs)
});
export { cmspage_filter_kind1 as "cmsPage_filter_kind" }